import React from 'react';
import { Table } from 'semantic-ui-react';
import { states } from '@/constants/lifecycle';
import CompactTableHeader from '@/components/table/CompactTableHeader';
import TableErrorRow from '@/components/table/TableErrorRow';

const UsersGroupsTableHeader = ({
  children,
  error,
  onErrorDismiss,
  readStatus,
}) => (
  <Table.Header className="aridhia-users-groups-table-header" fullWidth>
    {readStatus === states.PENDING && (
      <CompactTableHeader isLoading numberOfColumns={3} className="aridhia-users-groups-header" />
    )}
    <TableErrorRow error={error} onErrorDismiss={onErrorDismiss} numberOfColumns={3} />
    { children }
  </Table.Header>
);

export default UsersGroupsTableHeader;
